import { createSelector, MemoizedSelector } from '@ngrx/store';
import { selectLayoutState } from './layout.selectors';
import { selectRouterState } from '../../selectors';
import { getUser } from '../../authentication/selectors/auth.selectors';
import { OpenCreateDialog } from '../../forms/forms.actions';
import { NavigationState } from '../reducers/navigation.reducer';
import { Navigation } from '@digitaix/types';

export const selectNavigationState: MemoizedSelector<
  any,
  NavigationState
> = createSelector(
  selectLayoutState,
  state => state.navigation
);

export const getNavigationConfig: MemoizedSelector<
  any,
  Navigation
> = createSelector(
  selectNavigationState,
  state =>
    state.config.map(item =>
      item.add
        ? {
            ...item,
            actionIcon: 'plus-circle-outline',
            actionIconSvg: true,
            action: new OpenCreateDialog(item.add)
          }
        : item.action && !item.actionIcon
        ? {
            actionIcon: 'plus-circle-outline',
            actionIconSvg: true,
            ...item
          }
        : item
    )
);

export const getRoleFilteredNavigationConfig: MemoizedSelector<
  any,
  Navigation
> = createSelector(
  getNavigationConfig,
  getUser,
  (config, user) => {
    if (!user || (user.roles || []).includes('admin')) {
      return config;
    } else {
      return config.filter(nav => {
        if (nav.roles && nav.roles.length) {
          return nav.roles.some(r => user.roles.includes(r));
        } else {
          return true;
        }
      });
    }
  }
);

export const getNavigationParams = createSelector(
  selectRouterState,
  state => state && state.state.params
);
